<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <card-component titulo="Lista de descrição padrão" componente="null" usuario="null">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col mb-3">
                                <input-container-component titulo="Descricao" id="inputNome">
                                    <input type="text" class="form-control" id="inputNome" placeholder="Informe o Nome"
                                        v-model="busca.descricao" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                        </div>
                        <table-component :dados="descricoes.data" componentpai="fornecedor" :editar="{ 
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalDescricaoAtualizar'
                        }" :remover="{
                            visivel: false,
                            dataToggle: 'modal',
                            dataTarget: '#modalDescricaoRemover'
                        }" :titulos="{
                            id: { titulo: '', tipo: '' },
                            descricao: { titulo: 'Descrição', tipo: 'texto' },
                        }"></table-component>
                    </template>
                    <template v-slot:rodape>
                        <div class="row">
                            <div class="col-10">
                                <paginate-component>
                                    <li v-for="l, key in descricoes.links" :key="key"
                                        :class="l.active ? 'page-item active' : 'page-item'"><a class="page-link"
                                            v-html="l.label" @click="paginacao(l)"></a></li>
                                </paginate-component>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn btn-primary btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalDescricao">
                                    Adicionar
                                </button>
                            </div>
                        </div>
                    </template>
                </card-component>
            </div>
        </div>
        <modal-component id="modalDescricao" titulo="Adicionar Descricao">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="transacaoDetalhes" titulo="Cadastro realizado com sucesso!"
                    v-if="transacaoStatus == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="transacaoDetalhes" titulo="Erro ao cadastrar."
                    v-if="transacaoStatus == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Descricao" id="novoDescricao">
                        <input type="text" class="form-control" id="novoDescricao" placeholder="Informe a Descrição"
                            v-model="descricao">
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="salvar()">Salvar</button>
            </template>
        </modal-component>

        <modal-component id="modalDescricaoAtualizar" titulo="Atualizar Descrição">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Descrição atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Descrição" id="atualizarDescricao">
                        <input type="text" class="form-control" id="atualizarDescricao"
                            placeholder="Informe a Descrição" v-model="$store.state.item.descricao">
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="atualizarDescricao()">Atualizar</button>
            </template>
        </modal-component>

        <modal-component id="modalDescricaoRemover" titulo="Remover Descricao">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Descricao removido com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao remover."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo v-if="$store.state.transacao.status != 'sucesso'">
                <div class="form-group">
                    <input-container-component titulo="Razão Social Descricao" id="removeDescricao">
                        <input type="text" class="form-control" id="removeDescricao"
                            placeholder="Informe a Razão Social Descricao" v-model="$store.state.item.descricao" disabled>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-danger" @click="removerDescricao()"
                    v-if="$store.state.transacao.status != 'sucesso'">Remover</button>
            </template>
        </modal-component>
    </div>
</template>

<script>
export default {
    props: ['user'],
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/descpadrao',
            urlPaginacao: '',
            urlFiltro: '',
            descricoes: { data: [] },
            descricao: '',
            transacaoStatus: '',
            transacaoDetalhes: {},
            busca: { descricao: '' },
            links: {}
        }
    },
    methods: {
        resetTransacao() {
            this.transacaoStatus = ''
            this.transacaoDetalhes = ''
            this.descricao = ''
        },
        atualizarDescricao() {
            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('descricao', this.$store.state.item.descricao)


            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        removerDescricao() {
            let confirmacao = confirm('Confirmar remoção do registro!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('_method', 'delete')

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        pesquisar() {
            let filtro = ''
            for (let chave in this.busca) {
                if (this.busca[chave]) {
                    if (filtro != '') {
                        filtro += ';'
                    }
                    filtro += chave + ':like:' + this.busca[chave]
                }
            }
            if (filtro != '') {
                this.urlPaginacao = 'page=1'
                this.urlFiltro = '&filtro=' + filtro + '%'
            } else {
                this.urlFiltro = ''
            }
            this.carregarLista()
        },
        paginacao(l) {
            if (l.url) {
                this.urlPaginacao = l.url.split('?')[1]
                this.carregarLista()
            }
        },
        carregarLista() {
            let url = this.urlBase + '?' + this.urlPaginacao + this.urlFiltro            
            
            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.descricoes = response.data 
                })
                .catch(errors => {
                })
        },
        salvar() {
            let formData = new FormData()

            formData.append('descricao', this.descricao)

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase, formData, config)
                .then(response => {
                    this.resetTransacao()
                    this.carregarLista()
                    this.transacaoStatus = 'sucesso'
                    this.transacaoDetalhes = {
                        mensagem: 'ID do registro: ' + response.data.id
                    }
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.transacaoStatus = 'erro'
                    this.transacaoDetalhes = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        }
    },
    mounted() {
        this.carregarLista()
        // Obtém o elemento da modal pelo ID
        const modalElement = document.getElementById('modalDescricao');

        // Adiciona o evento de fechamento da modal para resetar as variáveis
        modalElement.addEventListener('hidden.bs.modal', this.resetTransacao);
    },
    beforeUnmount() {
        // Remove o evento ao desmontar o componente para evitar vazamento de memória
        const modalElement = document.getElementById('modalDescricao');
        modalElement.removeEventListener('hidden.bs.modal', this.resetTransacao);
    },
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        },

        userJson() {
            return JSON.parse(this.user);
        },
    },
}
</script>
